export default "__VITE_ASSET__CiDnW6h2__"